//== DEFAULTS RAILS
import Rails from "@rails/ujs"
Rails.start()


// //== JQUERY
import $ from 'jquery'
window.$ = window.jQuery = $

// FANCYBOX
import { fancybox } from "components/fancybox";

//== BOOTSTRAP
import { Popper } from '@popperjs/core'
import * as bootstrap from 'bootstrap'

//== FONTAWESOME
import "@fortawesome/fontawesome-free/js/all"

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.content-clamp').forEach(function(clamp) {
        var link = clamp.nextElementSibling;
        if (clamp.scrollHeight > clamp.clientHeight) {
            link.style.display = 'inline-block';
            link.addEventListener('click', function(e) {
                e.preventDefault();
                if (clamp.classList.contains('is-clamped')) {
                    clamp.classList.remove('is-clamped');
                    link.textContent = 'Weniger lesen';
                } else {
                    clamp.classList.add('is-clamped');
                    link.textContent = 'Weiterlesen';
                }
            });
        } else {
            clamp.classList.remove('is-clamped');
        }
    });
});

document.addEventListener("DOMContentLoaded", function(event) {
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    })
});

document.addEventListener("DOMContentLoaded", function(event) {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl, {
            container: 'body'
        })
    })
});